<div class="backdrop" (click)="close()"></div>
<div class="chatWrapper">
    <div class="chatInner">
        <div class="container">
            <div class="row">
              <div class="chat_box">
                <div>
                  <div class="heading flex justify-content-between">
                    <h1>{{rfqInfo.rfqName}}, RFQ ID:{{ rfqInfo.id }}</h1>
                    <span class="close" (click)="close()"> <lucide-icon name="X" class="close_icon"></lucide-icon> </span>
                  </div>
          
                  <mat-tab-group animationDuration="0ms">
                    <mat-tab>
                      <ng-template mat-tab-label>
                        Comments
                        <!-- <span matBadge="5" class="badge" matBadgeOverlap="false" matBadgeColor="accent">3</span> -->
                      </ng-template>
          
                      <ng-container *ngIf="true">
                        <ul class="chat_list col-sm-12" #scrollMe>
                          <ng-container *ngIf="commentsList.length; else elseTemplate">
                            <li class="flex" *ngFor="let comment of commentsList; trackBy: trackComment">
                              <div
                                class="message col-sm-12"
                                [class]="comment.sender"
                                [ngClass]="{
                                    sender: comment.sender == this.currReceiver,
                                    receiver: comment.sender !== this.currReceiver
                                  }"
                              >
                                <div class="message_content" [class]="comment.sender">{{ comment.textMessage }}</div>
                                <span class="date">{{ comment.userName | titlecase }} {{ comment.createdOn | date: "MMM d, y, HH:mm" }}</span>
                              </div>
                            </li>
                          </ng-container>
                          <ng-template #elseTemplate>
                            <h4>No comments</h4>
                          </ng-template>
                        </ul>
                      </ng-container>
          
                      <div>
                        <div class="col-sm-12 comment_sec">
                          <label> Add Comments </label>
                          <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Comment here..." [(ngModel)]="comment"></textarea>
                          </mat-form-field>
                        </div>
                        <div class="btn_row">
                          <button mat-button class="btnCustom btn-trans"  (click)="close()">Close</button>
                          <button
                            mat-button
                            class="btnCustom btn-primary"
                            (click)="updateDataFunc()"
                            [disabled]="comment == ''"
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </mat-tab>
          
                    <mat-tab  [disabled]="true">
                      <ng-template mat-tab-label>
                        Files
                        <!-- <span matBadge="5" class="badge" matBadgeOverlap="false" matBadgeColor="accent">3</span> -->
                      </ng-template>
                      <div class="file_content">
                        <!-- <div
                          class="title"
                          *ngIf="(metaData.receivers && userRole !== USER_ROLE_KEYS.Supplier) || userRole !== USER_ROLE_KEYS.Operations"
                        >
                          <h3>Select files to share with {{ nextRole }}</h3>
                          <div class="icon_box" *ngIf="userRole !== USER_ROLE_KEYS.Customer && userRole !== USER_ROLE_KEYS.Supplier">
                            <lucide-icon name="Share2" class="icon" (click)="toggleCheckboxes()"></lucide-icon>         
                          </div>
                        </div> -->
          
                        <!-- <app-upload-dnd
                          *ngIf="(metaData.receivers && userRole == USER_ROLE_KEYS.Supplier) || userRole == USER_ROLE_KEYS.Operations"
                          (fileUploadEvent)="handleFileUpload($event)"
                          [documentInfo]="documentInfo"
                          [fileUploadConfig]="fileUploadConfig"
                        ></app-upload-dnd> -->
          
                        <div class="single-file flex justify-content-between" *ngFor="let file of fileList; let i = index">
                          <div class="flex file">
                            <div class="lst flex">
                              <div *ngIf="showCheckboxes" class="formGroup checkboxItem">
                                <mat-checkbox type="checkbox" [(ngModel)]="file.isChecked"></mat-checkbox>
                              </div>
                              <div class="rfq-item rfq-icon">
                                <lucide-icon name="FileText" class="icon" *ngIf="!showCheckboxes"></lucide-icon>
                                <h4 class="name" matTooltip="{{ file?.fileObj?.fileName }}">
                                  {{ file?.fileObj?.fileName }}
                                </h4>
                              </div>
                            </div>
          
                            <div class="flex download" (click)="downloadFile(file?.fileObj?.fileName, file?.fileObj?.fileId)">
                              <lucide-icon name="Download" class="icon"></lucide-icon>
                            </div>
                          </div>
                          <div class="info">
                            <h4 class="name">{{ file?.fileObj?.fileSize }}</h4>
                          </div>
                        </div>
                      </div>
          
                      <!-- <div class="btn_row">
                        <button mat-button class="btnCustom btn-trans" (click)="close()">Close</button>
                        <button mat-button class="btnCustom btn-primary" (click)="submitUploadedFiles()">Share with {{ nextRole }}</button>
                      </div> -->
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </div>
            </div>
          </div>
    </div>              
</div>

